import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { action, computed, observable } from 'mobx'

export interface FilingYear {
  id: string
  year: number
  inactive: boolean
  dateCreated: Date
}

export type TxfWorklayerJobProps = ModelProps<TxfWorklayerJob>

export class TxfWorklayerJob extends Model<TxfWorklayerJob> {
  id = Id.none

  @observable accessor filingYears: FilingYear[] = []

  @computed
  get activeFilingYears() {
    return this.filingYears
      .filter((filingYear) => !filingYear.inactive)
      .sort((a, b) => a.year - b.year)
  }

  @action.bound
  override set({ ...props }: Partial<TxfWorklayerJobProps>): this {
    return super.set(props)
  }
}
